import { render, staticRenderFns } from "./CheckedNew.vue?vue&type=template&id=20787196"
import script from "./CheckedNew.vue?vue&type=script&lang=js"
export * from "./CheckedNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports